import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Switch, Route, Redirect } from "react-router-dom";

import { firestoreRef } from "api";
import Main from "modules/home/Main";
import News from "modules/news/News";
import Forum from "modules/forum/Forum";
import Topup from "modules/Topup/Topup";
import ExamPage from "modules/exam/ExamPage";
import LoginLayout from "layouts/LoginLayout";
import Results from "modules/results/Results";
import Profile from "./modules/profile/Profile";
import NewsPost from "modules/news/post/NewsPost";
import Result from "modules/results/result/Result";
import ForumPost from "modules/forum/post/ForumPost";
import useAuthListener from "helpers/useAuthListener";
import DashboardLayout from "layouts/DashboardLayout";
import Loader from "components/Loaders/FullScreenLoader";
import LoginPage from "modules/auth/user/login/LoginPage";
import SignUpPage from "modules/auth/user/signup/SignUpPage";
import ExamQuizPage from "modules/exam/examQuiz/ExamQuizPage";
import CompleteSignUpPage from "modules/auth/user/completeSignUp/CompleteSignUpPage";
import ForgotPasswordPage from "modules/auth/user/forgotPassword/ForgotPasswordPage";
import PhoneNumberVerification from "modules/auth/user/phoneNumberVerification/PhoneNumberVerification";
import PricingPage from "modules/Topup/pricing/PricingPage";
import AllResult from "modules/results/AllResult";

function useFirestoreUserListener() {
  const authUser = useSelector(state => state.authState.user);
  const dispatch = useDispatch();
  // let [s, setS] = useState(null);
  useEffect(() => {
    if (authUser) {
      return firestoreRef
        .collection("users")
        .doc(authUser.uid)
        .onSnapshot(function(doc) {
          dispatch({ type: "FIRESTORE_USER", payload: doc.data() });
          // setS(doc.data());
        });
    }
    //eslint-disable-next-line
  }, [authUser]);
  // return s;
}

function withLoginCheck(Component) {
  return function AnonComponent(props) {
    const firestoreUser = useSelector(state => state.authState.firestoreUser);
    if (firestoreUser.anon) {
      return <Redirect to="/login" />;
    }
    return <Component {...props} />;
  };
}

function App() {
  useAuthListener();

  const firestoreUser = useSelector(state => state.authState.firestoreUser);
  // const firestoreUser = useFirestoreUserListener();

  useFirestoreUserListener();
  // console.log("@@firestoreUser", firestoreUser);

  if (!firestoreUser || !firestoreUser.uid) {
    return <Loader />;
  }

  if (!firestoreUser.anon && !firestoreUser.completed) {
    return (
      <LoginLayout>
        <Route path="/complete" exact component={CompleteSignUpPage} />
        <Redirect to="/complete" />
      </LoginLayout>
    );
  }

  return (
    <React.Fragment>
      <Switch>
        <Route
          path={["/login", "/signup", "/fp"]}
          render={() => {
            return (
              <LoginLayout>
                <Switch>
                  <Route path="/login" exact component={LoginPage} />
                  <Route path="/signup" exact component={SignUpPage} />
                  <Route path="/fp" exact component={ForgotPasswordPage} />
                </Switch>
              </LoginLayout>
            );
          }}
        />
        <Route
          path="/"
          render={props => (
            <DashboardLayout {...props}>
              <Switch>
                <Route path="/" exact component={Main} />
                <Route
                  path="/verifyPhone"
                  exact
                  component={PhoneNumberVerification}
                />
                <Route path="/forum" exact component={Forum} />
                <Route path="/forum/:key" exact component={ForumPost} />
                <Route path="/news" exact component={News} />
                <Route path="/news/:key" exact component={NewsPost} />
                <Route
                  path="/profile"
                  exact
                  component={withLoginCheck(Profile)}
                />
                <Route path="/exam" exact component={ExamPage} />
                <Route
                  path="/exam/:id"
                  exact
                  component={withLoginCheck(ExamQuizPage)}
                />
                <Route path="/topup" exact component={Topup} />
                <Route path="/result" exact component={Results} />
                <Route path="/result/:key" exact component={Result} />
                <Route path="/all_result/:key" exact component={AllResult} />
                <Route path="/exams" exact component={ExamPage} />
                <Route path="/pricing" exact component={PricingPage} />
                <Redirect to="/" />
              </Switch>
            </DashboardLayout>
          )}
        />
      </Switch>
    </React.Fragment>
  );
}

export default App;
